import { useEffect } from 'react';
import { setPageSEO } from '@/utils/seoUtils';

/**
 * Custom hook to set page title and SEO meta tags
 * @param pageKey - The key from PAGE_SEO_CONFIG in seoUtils
 * @param customTitle - Optional custom title to override default
 * @param deps - Optional dependencies array for useEffect
 */
export function usePageTitle(
  pageKey: string, 
  customTitle?: string,
  deps: React.DependencyList = []
): void {
  useEffect(() => {
    setPageSEO(pageKey, customTitle);
    
    // Cleanup function to reset title when component unmounts
    return () => {
      // Reset to default home title when navigating away
      if (pageKey !== 'home') {
        setPageSEO('home');
      }
    };
  }, [pageKey, customTitle, ...deps]);
}